import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { AuthInterceptor } from './features/auth/interceptors/http.interceptor';
import { MessageService } from 'primeng/api';
import { Globals } from './shared/global';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  KeycloakAngularModule,
  KeycloakBearerInterceptor,
  KeycloakService,
} from 'keycloak-angular';
import { GlobalErrorHandler } from './core/error-handler/global-error-handler';

// Keycloak initialization
// function initializeKeycloak(keycloak: KeycloakService) {
//   return () =>
//     keycloak.init({
//       config: {
//         url: 'https://jbnsabvjoeapp.j-b.group/',
//         realm: 'fds',
//         clientId: 'fds-client',
//       },
//       initOptions: {
//         onLoad: 'check-sso', // do NOT force login
//         // checkLoginIframe: false,
//         // silentCheckSsoRedirectUri:
//         //   window.location.origin + '../assets/silent-check-sso.html',
//       },

//       enableBearerInterceptor: true,
//     });
// }

// Application configuration
export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    Globals,
    provideRouter(routes),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initializeKeycloak,
    //   multi: true,
    //   deps: [KeycloakService],
    // },
    KeycloakService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptors([AuthInterceptor])),
    importProvidersFrom(
      BrowserAnimationsModule,
      BrowserModule,
      CommonModule,
      KeycloakAngularModule // include Keycloak module if you want
    ),
  ],
};
